import React from 'react';
import SEO from '../../components/SEO';
import Layout from '../../layouts/index';
import Call from '../../components/Call';
import Faq from "react-faq-component";
const data = {
    title: "Frequently Asked Questions",
    rows: [
        {
            title: "Is OneAction a political party?",
            content: `Not yet, OneAction is building towards being a political party but will only register as a party when we have enough support to take seats in parliament. <a href="/roadmap" target="_blank"> See roadmap for more info</a>`,
        },
        {
            title: "Isn’t it dangerous to have everyday people making decisions about the government policy?",
            content:
                `OneAction is building an online platform to allow kiwis to participate in setting the direction and the outcomes they want to see in Aotearoa New Zealand (“the what” and “the where”). 
                Development of policy ("the how") will be done by experts and community leaders, using the best available evidence. We’re not embarking on a
                 “direct democracy” project where policy decisions are made by non-experts based on their opinions. <a href="/digital-democracy">See digital democracy for more info.</a>`
        },
        {
            title: "Online democracy platform? What about security?",
            content: `Building a secure and trustworthy platform for online democratic participation is a huge challenge, and yes security is a big part of that, but it can be done, and emerging technologies such as <a href="https://en.wikipedia.org/wiki/Blockchain" target="_blank">blockchain</a> which allow for tamper-proof transactions will likely be very useful. but make no mistake, it’s a huge challenge and there’s always some risk involved with innovation.
             But it also presents an exciting opportunity for researchers and software developers to work on the cutting edge of eParticipation and deliberative democracy. Get in contact!`,
        },
        {
            title: "Free membership? How are you going to fund OneAction?",
            content: "Once the TallyUp reaches 25,000 we will open for micro donations from members which will be used to fund OneAction. OneAction is wholly owned and funded by our members. No external influencers. No fat cats! Learn more about funding.",
        },
        {
            title: "Where are you on Social media!? You know it’s 2020 right!?",
            content: "Social media platforms are private, profit-driven corporations. They have their place, but we’re doing our own thing. OneAction is 100% owned and operated by its community. We see ourselves as adjacent to social media, not contained within it. But that doesn’t mean you can’t use social media to tell your friends and whānau about us. OneAction never uses paid advertisement, we believe that our vision is big enough to carry itself by word of mouth.",
        },
        {
            title: "200,000 members before you register as a party? Isn't that a bit unrealistic?",
            content: "200,000 people is approximately 7.5% of the total voter turnout in the 2017 general election, so while it’s a big number, it’s still only just enough to get over the 5% margin to win seats in parliament. Unrealistic, perhaps, it’s certainly a lofty goal, but in our view, a lot of kiwis would like a bit more of a say in the direction of Aotearoa New Zealand. Of course, there will be plenty of people who prefer to stick to the traditional way of doing things, that’s fine, they’re not the ones we’re looking for. Are there 7.5% of us who want to try a new way of doing politics? we firmly believe so.",
        },
        {
            title:"Where are your polices? What does OneAction actually do?",
            content:"Because we’re starting from the ground up without big funders. We need to work through several stages to build up the organisation. The purpose of OneAction is to give our members a voice and then turn that voice into policy. Once we have 150,000 members (quorum stage) policy will be built based on input from the membership via the online digital democracy platform. See roadmap for more info"
        },
        {
            title:"Why use email for the TallyUp? Isn’t that a bit oldschool?",
            content:"Yeah it is and that's kinda the idea, email is the most universal and accessible form of internet communication. It’s also cheap to set up and run which is required to start OneAction on a shoestring (i.e. no fat cat donors!)"
        },
        {
            title:"What about the digital divide? Not everyone has internet access or knows how to use the internet. Aren’t you being a bit exclusive?",
            content:"While internet access and usage in Aotearoa New Zealand is already very high, this is an issue, but it’s important to remember that the current methods for people to participate and have their voice heard aren’t that great, so OneAction will improve the situation, rather than make it worse. We have three key responses to the digital divide:<ul><li>Our vision is to give anyone with a $50 smart phone a voice in the decisions which shape Aotearoa New Zealand, and we think that’s pretty powerful.</li><li>We will create a network of volunteer ‘buddies’ to help people who don’t have internet knowledge or access</li><li>As time passes, OneAction will grow and the digital divide will shrink. We feel that now is the time to embark on this journey, rather than waiting for the perfect conditions</li></ul>"
        }
    ],
};
const styles = {
    // bgColor: 'white',
    titleTextColor: "#c25000",
    rowTitleColor: "#c25000",
    // rowContentColor: 'grey',
    // arrowColor: "red",
};
 
const config = {
    // animate: true,
    // arrowIcon: "V",
};
const Contact = props => (
  <Layout bodyClass="page-contact">
    <SEO title="FAQ" />
    <div className="intro intro-small">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1>FAQ</h1>
          </div>
        </div>
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-12">
          <Call button={false} />
        </div>
  

        <div className="col-12 pt-5 pb-8">
        <div>
                <Faq data={data} styles={styles} config={config} />
            </div>
        </div>
       
      </div> 
    </div>
  </Layout>
);

export default Contact;
